import { connect } from 'react-redux'
import PrintPreview from './PrintPreview.jsx'
import {
    closePrintPreview,
    print,
} from 'redux/print/actions'

const mapDispatchToProps = (dispatch, getState) => ({
    close: () => {
        dispatch(closePrintPreview())
    },
    print: () => dispatch(print()),
})

export const PrintPreviewContainer = connect(
    undefined,
    mapDispatchToProps,
)(PrintPreview)
